import React, { useCallback } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import classnames from 'classnames/bind';
import { Input, Select } from '@miroculus/nucleo';
import styles from './ProtocolFilters.scss';
const cx = classnames.bind(styles);
const SORT_OPTIONS = [
    {
        value: 'latest',
    },
    {
        value: 'oldest',
    },
];
const ProtocolFilters = ({ searchText, dateRange, selectedType, types = [], onSearchTextChange, onDateRangeChange, onTypeChange, selectedSortMethod, onSortMethodChange, }) => {
    const handleTypeChange = useCallback((newTypeValue) => {
        if (onTypeChange) {
            onTypeChange(types.find(({ value }) => value === newTypeValue) || null);
        }
    }, [types, onTypeChange]);
    const handleSortMethodChange = useCallback((newSortMethodValue) => {
        if (onSortMethodChange) {
            onSortMethodChange(newSortMethodValue || SORT_OPTIONS[0].value);
        }
    }, [onSortMethodChange]);
    const typeOptions = [{ value: 'All types' }, ...types];
    return (React.createElement("div", { className: cx('container') },
        React.createElement(Input, { name: "search", value: searchText, onChange: onSearchTextChange, placeholder: "Search...", "data-testid": "input-search-bar" }),
        onDateRangeChange && (React.createElement(DateRangePicker, { calendarClassName: cx('calendar'), calendarIcon: null, className: cx('daterange'), yearAriaLabel: "Year input", monthAriaLabel: "Month input", dayAriaLabel: "Day input", value: dateRange, onChange: onDateRangeChange })),
        types.length > 1 && (React.createElement("div", { className: cx('types') },
            React.createElement(Select, { name: "type", options: typeOptions, value: selectedType, onChange: handleTypeChange }))),
        onSortMethodChange && (React.createElement("div", { className: cx('sortBy'), "data-testid": "sortBy" },
            React.createElement(Select, { name: "sortBy", options: SORT_OPTIONS, value: selectedSortMethod, onChange: handleSortMethodChange })))));
};
export default ProtocolFilters;
